import(/* webpackMode: "eager" */ "/opt/build/repo/app/page.js");
